import { ReservationDataService } from '@/common/services/details/details.service';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'fe-location-detail',
    templateUrl: './location-detail.component.html',
    styleUrls: ['./location-detail.component.scss'],
})
export class LocationDetailComponent implements OnInit {
    @Input() displayPrecheckin?: boolean;

    public infoServiceVisible = false;
    public addressLocation = '';
    public openHour = '';
    public closeHour = '';
    public iframe!: string;

    reservationDetails: DetailsInterface | null = null;

    constructor(private reservationDataService: ReservationDataService) {}

    ngOnInit(): void {
        this.reservationDataService.getDetails().subscribe((details) => {
            this.reservationDetails = details;

            const lat =
                this.reservationDetails?.data?.reservationDetails.branchPickup
                    .lat;
            const lon =
                this.reservationDetails?.data?.reservationDetails.branchPickup
                    .lon;

            this.iframe =
                '<iframe width="400" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com.mx/maps?q=' +
                lat +
                ',' +
                lon +
                '&amp;num=1&amp;ie=UTF8&amp;ll=' +
                lat +
                ',' +
                lon +
                '&amp;spn=0.005704,0.008304&amp;t=m&amp;z=14&amp;output=embed"></iframe>';

            const branchPickup =
                this.reservationDetails?.data?.reservationDetails?.branchPickup;

            if (branchPickup) {
                this.addressLocation = [
                    branchPickup.branchName ? `${branchPickup.branchName}` : '',
                    branchPickup.street ? `${branchPickup.street}` : '',
                    branchPickup.number ? `${branchPickup.number},` : '',
                    branchPickup.colony ? `${branchPickup.colony}, ` : '',
                    branchPickup.zipCode ? `${branchPickup.zipCode}` : '',
                    branchPickup.city ? `${branchPickup.city}` : '',
                ]
                    .filter((part) => part)
                    .join(' ')
                    .trim();

                this.openHour = branchPickup.openHour
                    ? this.formatTime(branchPickup.openHour)
                    : '';
                this.closeHour = branchPickup.closeHour
                    ? this.formatTime(branchPickup.closeHour)
                    : '';
            } else {
                this.addressLocation = '';
                this.openHour = '';
                this.closeHour = '';
            }
        });
    }

    toggleInfoService() {
        this.infoServiceVisible = !this.infoServiceVisible;
    }

    formatTime(time: string): string {
        const parts = time.split(':');
        let hour = parseInt(parts[0], 10);
        const minutes = parts[1];
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12;
        return `${hour}:${minutes} ${ampm}`;
    }
}
